import { Design, ObjectClass } from '@app/types';

export function normalizeDisambiguationPrompt(
  itemWithOverride: {
    disambiguationPromptId?: string;
  },
  { components: { objects } }: Design
): void {
  if (
    !itemWithOverride.disambiguationPromptId
    // No matching prompt.
    || !objects.some(({ _class, id }) => {
      return (
        _class === ObjectClass.prompt
        && id === itemWithOverride.disambiguationPromptId
      );
    })
  ) {
    delete itemWithOverride.disambiguationPromptId;
  }
}
